import React, { useEffect, useState } from "react";
import { ModeQuestion, QuestionTypeEnum } from "../../../constants";
import ChooseText from "./choose-text";
import ChooseImage from "./choose-image";
import ChooseVideo from "./choose-video";
import TrueOrFalse from "./true-or-false";
import ChooseMultiText from "./choose-multi-text";
import ChooseMultiImage from "./choose-multi-image";
import ChooseMultiVideo from "./choose-multi-video";
import Connect from "./connect";
import ShortText from "./short-text";
import FileUpload from "./file-upload";
import Video from "./video";
import Mp3 from "./mp3";
import DropDown from "./drop-down";
import "./style.scss";
import { Spin } from "antd";
import { useAddLesson } from "../../../stores/stores";
import {
  ConnectQuestionData,
  QuestionData,
} from "../../../types/course-construction";
import { getQuizById } from "../../../service/course-construct";
import Calculated from "./calculated";
import CalculatedMulti from "./caculated-multi";
import Essay from "./essay";
import Numerical from "./numerical";

function QuestionItem() {
const question = useAddLesson((state: any) => state.question);
  const setQuestion = useAddLesson((state: any) => state.setQuestion);
  const modeQuestion = useAddLesson((state) => state.modeQuestion);
  const { currentQuizVersionId, setQuizInfo, setCurrentQuizVersionId } =
    useAddLesson();
  const setQuestionSettingsBe = useAddLesson(
    (state) => state.setQuestionSettingsBe
  );
  const setQuizInfoData = useAddLesson((state) => state.setQuizInfo);
  const [currentQuizId, setCurrentQuizId] = useState<number>(0);

  const [loadingQuestion, setLoadingQuestion] = useState<boolean>(false);
  const [questionData, setQuestionData] = useState<QuestionData>(
    {} as QuestionData
  );
  const [connectQuestionData, setConnectQuestionData] =
    useState<ConnectQuestionData>({} as ConnectQuestionData);

  useEffect(() => {
    if (question.id) {
      // Khởi tạo
      setCurrentQuizId(question.id);
    }
  }, [question.id]);

  useEffect(() => {
    if (Object.keys(questionData).length > 0) {
      setQuizInfoData(questionData);
    }
  }, [questionData]);

  useEffect(() => {
    // Check version khác của quizz
    if (currentQuizVersionId) {
      const getQuizByVersion = async () => {
        setLoadingQuestion(true);

        const quizDetail = await getQuizById(currentQuizVersionId);

        if (question.type === QuestionTypeEnum.CONNECT) {
          setConnectQuestionData(quizDetail.data.body);
        } else {
          setQuestionData(quizDetail.data.body);
        }
        if (quizDetail.data.body.id !== question.id) {
          setQuestion({
            ...quizDetail.data.body,
            id: question.id,
          });
        }
        setLoadingQuestion(false);
      };
      getQuizByVersion();
    }
    return () => setCurrentQuizVersionId(null);
  }, [currentQuizVersionId]);

  useEffect(() => {
    if (modeQuestion === "") {
      setQuestion({});
      setQuestionData({} as QuestionData);
    }
    if(modeQuestion === ModeQuestion.CREATE){
      setQuestionData({question: question.question} as QuestionData);
    }
  }, [modeQuestion]);

  useEffect(() => {
    getDetailQuestion();
  }, [currentQuizId, modeQuestion]);

  const getDetailQuestion = async (questId?: number) => {
    try {
      if (currentQuizId && modeQuestion === ModeQuestion.UPDATE) {
        setLoadingQuestion(true);
        setQuestionData({} as QuestionData);
        const quizDetail = await getQuizById(questId || currentQuizId);
        if (question.type === QuestionTypeEnum.CONNECT) {
          setConnectQuestionData(quizDetail.data.body);
        } else {
          setQuestionData(quizDetail.data.body);
        }
        setQuizInfo(quizDetail.data.body);
        setQuestionSettingsBe(quizDetail.data || {});
      }
    } catch (err: any) {
    } finally {
      setLoadingQuestion(false);
    }
  };

  const renderQuestionByType = () => {
    if (question.type)
      switch (question.type) {
        case QuestionTypeEnum.CHOOSE_TEXT:
          return <ChooseText dataFromApi={questionData} />;
        case QuestionTypeEnum.CHOOSE_IMAGE:
          return <ChooseImage data={questionData} />;
        case QuestionTypeEnum.CHOOSE_VIDEO:
          return <ChooseVideo data={questionData} />;
        case QuestionTypeEnum.TRUE_OR_FALSE:
          return <TrueOrFalse data={questionData} />;
        case QuestionTypeEnum.DROP_DOWN:
          return <DropDown data={questionData} />;
        case QuestionTypeEnum.CHOOSE_MULTI_TEXT:
          return <ChooseMultiText data={questionData} />;
        case QuestionTypeEnum.CHOOSE_MULTI_IMAGE:
          return <ChooseMultiImage data={questionData} />;
        case QuestionTypeEnum.CHOOSE_MULTI_VIDEO:
          return <ChooseMultiVideo data={questionData} />;
        case QuestionTypeEnum.CONNECT:
          return <Connect dataFromApi={connectQuestionData} />;
        case QuestionTypeEnum.SHORT_TEXT:
          return <ShortText data={questionData} />;
        case QuestionTypeEnum.FILE_UPLOAD:
          return <FileUpload dataFromApi={questionData} />;
        case QuestionTypeEnum.VIDEO:
          return <Video data={questionData} />;
        case QuestionTypeEnum.MP3:
          return <Mp3 data={questionData} />;
        case QuestionTypeEnum.CALCULATED:
          return <Calculated data={questionData} />;
        case QuestionTypeEnum.CALCULATED_SIMPLE:
          return <Calculated data={questionData} />;
        case QuestionTypeEnum.CALCULATED_MULTI:
          return <CalculatedMulti data={questionData} />;
        case QuestionTypeEnum.ESSAY:
          return <Essay data={questionData} />;
        case QuestionTypeEnum.NUMERICAL:
          return <Numerical data={questionData} />;
        default:
          return <></>;
      }
  };
  return (
    <div className="question-content-box">
      <Spin spinning={loadingQuestion}>{renderQuestionByType()}</Spin>
    </div>
  );
}

export default QuestionItem;
